module.exports = __webpack_public_path__ + "static/Montserrat-Light-a17f43cc60643d965636985afc00a221.ttf";